export const SIGN_UP_LOAD = 'sign_up_visit';
export const SIGN_UP_COMPLETE = 'sign_up';
export const EMAIL_VERIFIED = 'email_verified';
export const PLAN_SELECTED = 'plan_selected';
export const INTEGRATION_CREATED = 'integration_created';